module.exports = __webpack_public_path__ + "img/logo-maneki_logo.9377c8a9.png";